/* import __COLOCATED_TEMPLATE__ from './-title.hbs'; */
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Component from '@glimmer/component';
import { modifier } from 'ember-modifier';
export default class DialogTitleComponent extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "DEFAULT_TAG_NAME", 'h2');
    _defineProperty(this, "ariaLabelledby", modifier((element, [dialogGuid]) => {
      let $dialog = document.getElementById(dialogGuid);
      $dialog.setAttribute('aria-labelledby', element.id);
      return () => {
        $dialog.removeAttribute('aria-labelledby');
      };
    }));
    let {
      dialogGuid: _dialogGuid
    } = this.args;
    if (_dialogGuid === undefined) {
      throw new Error('<Dialog::-Title /> is missing a parent <Dialog /> component.');
    }
  }
  get tagName() {
    return this.args.as || this.DEFAULT_TAG_NAME;
  }
}